// objIsEmpty
import {
    enum_directions,
    enum_featuresMinPoints,
    enum_langCodes,
    enum_lockState,
    enum_lockTypes,
    enum_moreInfo_featuresIds_s,
    enum_moveToOptions,
    enum_questEventStartClockTypes_s,
    enum_questEventStatus,
    enum_questTicketStatus,
    enum_screenSizesOptions_n,
    enum_urlParams,
    mapTilerStyles_s
} from "../../functions/src/shareCode/Share_S_Enum";
import {gv_urls} from "@/scripts/S_GlobalVar";
import {FB_File, FB_Wysiwyg} from "../../functions/src/shareCode/Share_S_Classes";
import {
    validator_class_fb,
    validator_obj_fb,
    validator_textByLangCode_fb
} from "../../functions/src/shareCode/Share_S_Validator";
import {format_duration_hhmmss, format_sizeBytes_s} from "../../functions/src/shareCode/Share_S_Format";
import {route_addLangToPath_s} from "@/router";
import {obj_forEach_f} from "../../functions/src/shareCode/Share_S_Obj";
import {date_getDurationToStartEvent_seconds, date_newDate_fd} from "./S_Date";
import {
    ass_img_diffLevel0_gray,
    ass_img_diffLevel1_c,
    ass_img_diffLevel2_c,
    ass_img_diffLevel3_c,
    ass_img_diffLevel4_c,
    ass_img_diffLevel5_c,
    ass_img_flagEgypt_c,
    ass_img_flagFrench_c,
    ass_img_flagIsrael_c,
    ass_img_flagNetherlands_c,
    ass_img_flagSpain_c,
    ass_img_flagUsa_c,
} from "../assets/scripts/Ass_Files";
import {ass_strings} from "../../functions/src/shareCode/Share_Ass_Dictionary";

// helper__finishRiddle
export const helper_getFinishRiddlesIds_fan = (ts_riddles_byRiddleId_c, qb_riddles_ac) => {

    let ans = []
    if(ts_riddles_byRiddleId_c == null)
        return ans


    qb_riddles_ac.forEach((qb_riddle_c, riddleIndex) => {
        if(helper_finishRiddle_fb(qb_riddle_c, ts_riddles_byRiddleId_c[qb_riddle_c.qbr_riddleId_n])){
            ans.push(qb_riddle_c.qbr_riddleId_n)
        }
    })

    return ans
}

// helper_getScreenSizeCssClass_s
export const helper_getScreenSizeCssClass_s = (screenSize_en) => {

    switch (screenSize_en) {
        case enum_screenSizesOptions_n.mobile:
            return "lc_mobile"
        case enum_screenSizesOptions_n.tablet_small:
            return "lc_tablet_small"
        case enum_screenSizesOptions_n.tablet_big:
            return "lc_tablet_big"
        case enum_screenSizesOptions_n.laptop:
            return "lc_laptop"
    }
}

// helper_finishRiddle
export const helper_finishAllRiddle_fb = (missionsList_ac, riddleStatus_byRiddleId_c) => {


    for(let i=0; i< missionsList_ac.length; i++){
        let qb_riddle_c = missionsList_ac[i]
        if(!helper_finishRiddle_fb(qb_riddle_c, riddleStatus_byRiddleId_c[qb_riddle_c.qbr_riddleId_n])){
            return false
        }
    }

    return true

}
// total finish riddleNum
export const helper_totalFinishRiddleNum_fn = (missionsList_ac, riddleStatus_byRiddleId_c) => {

    let ans_n = 0
    for(let i=0; i< missionsList_ac.length; i++){
        let qb_riddle_c = missionsList_ac[i]
        if(helper_finishRiddle_fb(qb_riddle_c, riddleStatus_byRiddleId_c[qb_riddle_c.qbr_riddleId_n])){
            ans_n++
        }
    }

    return ans_n

}

// helper_finishRiddle
export const helper_finishRiddle_fb = (qb_riddle_c, riddleStatus_c) => {

    if(qb_riddle_c == null){
        return false
    } else if(qb_riddle_c.qbr_locks_ac.length === 0){
        return true
    }else if(riddleStatus_c == null){
        return false
    }else if(riddleStatus_c.rs_unlock_byLockId_c == null){
        return false
    }else {
        let ans = true

        for(let lockId_n in qb_riddle_c.qbr_locks_ac){
            ans = ans && helper_finishLock_fb(riddleStatus_c, lockId_n, qb_riddle_c.qbr_locks_ac[lockId_n].qbrl_type_e)
        }

        return ans
    }
}

// helper_getMissionScore_fb
export const helper_getMissionScore_fb = (qb_riddle_c, riddleStatus_c) => {

    let score_n = 0

    // calculate locks
    obj_forEach_f(riddleStatus_c.rs_unlock_byLockId_c, (rs_unlock_c, lockIndex_n) => {

        let qbr_lock_c = qb_riddle_c.qbr_locks_ac[lockIndex_n]

        switch(qbr_lock_c.qbrl_type_e){

            case enum_lockTypes.VIDEO:
            case enum_lockTypes.IMAGE:
                if(rs_unlock_c.rsud_lockState_e === enum_lockState.approved){
                    score_n += qbr_lock_c.qbrl_points_n
                }
                break;
            case enum_lockTypes.TRIVIA:
                for(let ansIndex_n in riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n].rsud_quizUserAns_byQuestionIndex_as){
                    let questionsAns_an = riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n].rsud_quizUserAns_byQuestionIndex_as[ansIndex_n]

                    if(questionsAns_an != null){
                        score_n += qbr_lock_c.qbrl_points_n / qbr_lock_c.qbrl_questions_ac.length
                    }
                }
                break;
            case enum_lockTypes.OPTIONS:
            case enum_lockTypes.INCLUDE_WORD:
            case enum_lockTypes.WORDS:
            case enum_lockTypes.QUIZ:
            case enum_lockTypes.REGULAR_EXPRESSION:
            case enum_lockTypes.QR_CODE:
                score_n += qbr_lock_c.qbrl_points_n
                break;

        }
    })

    // remove clues
    obj_forEach_f(riddleStatus_c.rs_clues_byClueId_c, (rs_clue_c, index_n) => {
        score_n -= qb_riddle_c.qbr_clues_ac[index_n].qbrc_pointsWorth_n
    })

    return score_n

}

// helper_arrToObj_fo
export const helper_arrToObj_fo = (arr_a, value_f) => {
    let ans = {}
    arr_a.forEach(item => {
        ans[item] = value_f(item)
    })

    return ans
}

// helper_finishLock_fb
export const helper_finishLock_fb = (riddleStatus_c, lockIndex_n, riddleType_e) => {

    if(!riddleStatus_c){
        return false
    }

    const rs_unlockData_c = riddleStatus_c.rs_unlock_byLockId_c && riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n]

    switch(riddleType_e){
        case enum_lockTypes.TRIVIA:
        case enum_lockTypes.QUIZ:
        case enum_lockTypes.WORDS:
        case enum_lockTypes.INCLUDE_WORD:
        case enum_lockTypes.OPTIONS:
            return rs_unlockData_c != null

        case enum_lockTypes.GPS:
            return riddleStatus_c.rs_m_finishActionLock_b(lockIndex_n)


        case enum_lockTypes.IMAGE:
        case enum_lockTypes.VIDEO:
            return rs_unlockData_c
                && (rs_unlockData_c.rsud_lockState_e === enum_lockState.approved || rs_unlockData_c.rsud_skip_b)

    }

}

// helper_getRiddleAttRiddleId_fc
export const helper_getRiddleWithRiddleId_fc = (qb_riddles_ac, riddleId_n) =>{

    for(let i=0; i< qb_riddles_ac.length; i++){
        if(qb_riddles_ac[i].qbr_riddleId_n == riddleId_n)
            return qb_riddles_ac[i]
    }

    return null

}

// helper_getRiddleAttRiddleId_fc
export const helper_getRiddleIndexWithRiddleId_fn = (qb_riddles_ac, riddleId_n) =>{

    for(let i=0; i< qb_riddles_ac.length; i++){
        if(qb_riddles_ac[i].qbr_riddleId_n === riddleId_n)
            return i
    }

    return null

}

// helper_isIos_b
export const helper_isIos_b = () => {
    return navigator.userAgent.match(/ipad|ipod|iphone/i);
}

// copyStringToClipboard
export const helper_copyStringToClipboard = (str) => {

    let el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);

    try{

        let range,
            selection;
        if (helper_isIos_b()) {
            range = document.createRange();
            range.selectNodeContents(el);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            el.setSelectionRange(0, 999999);
        } else {
            el.setAttribute('readonly', '');
            el.style = {position: 'absolute', left: '-9999px'};
            el.select();
        }

        document.execCommand("copy");
        document.body.removeChild(el);
    }catch (e) {

        // if failed try explore
        window.clipboardData.setData('Text', str);
        document.body.removeChild(el);

    }
}

// helper_getTicketUrl
export const helper_getTicketUrl = (ticketId) => {
    const link_prefix = gv_urls.tq_basicUrl
    const link_suffix = `${route_addLangToPath_s(enum_moveToOptions.player_play_entry_ticket)}?${enum_urlParams.ticketId}=${ticketId}`

    return link_prefix + link_suffix;
}

// helper_getFbClassSize_s
export const helper_getFbClassSize_s = (fbClass_C) => {

    let size_n = JSON.stringify(fbClass_C).length
    let children_a = [fbClass_C]
    while(children_a.length > 0){

        let newChildren_a = []

        children_a.forEach(child => {
            for(let key in child){
                let data = child[key]
                if(validator_class_fb(data, FB_Wysiwyg)){
                    data.w_files_ac.forEach(file_c => {
                        size_n += file_c.fi_sizeBytes_n
                    })
                }else if(validator_class_fb(data, FB_File)){
                    size_n += data.fi_sizeBytes_n
                }else if(validator_obj_fb(data)){
                    newChildren_a.push(data)
                }
            }
        })

        children_a = newChildren_a

    }

    return format_sizeBytes_s(size_n)

}

// helper_doForEachFileInfbClass_s
export const helper_doForEachFileInFbClass_s = (fbClass_C, wyiwygCb_f, fileCb_f) => {

    let children_a = [fbClass_C]
    while (children_a.length > 0) {

        let newChildren_a = []

        children_a.forEach(child => {
            for (let key in child) {
                let data = child[key]
                if (validator_class_fb(data, FB_Wysiwyg)) {
                    wyiwygCb_f(data)
                } else if (validator_class_fb(data, FB_File)) {
                    fileCb_f(data)
                } else if (validator_obj_fb(data)) {
                    newChildren_a.push(data)
                }
            }
        })

        children_a = newChildren_a
    }

}

// helper_doForEachFileInfbClass_s
export const helper_forEachBlcFieldDo_f = (fbClass_C, do_f) => {

    let children_a = [fbClass_C]
    while (children_a.length > 0) {

        let newChildren_a = []

        children_a.forEach(child => {
            for (let key in child) {
                let data = child[key]

                if (validator_obj_fb(data)) {
                    if(validator_textByLangCode_fb(data)){
                        do_f(data, key)
                    }else{
                        newChildren_a.push(data)
                    }
                }
            }
        })

        children_a = newChildren_a
    }

}

// getClassAsObj
export const helper_getClassAsObj = (c, count=10) => {

    if(count <0){
        return null
    }

    if(!(c instanceof Object))
        return c;

    let ans = {}
    for(const x in c){

        if(c[x] == null)
            continue;

        if (c[x] instanceof Array){
            ans[x] = c[x].map(item => {
                return helper_getClassAsObj(item, count-1)
            })
        } else if(c[x] instanceof Object ){
            ans[x] =  helper_getClassAsObj(c[x], count-1)
        }else{
            ans[x] = c[x]
        }
    }
    return ans;
}

// helper_getDirectionByLangCode_e
export const helper_getDirectionByLangCode_fe = (langCode) => {
    switch(langCode){
        case enum_langCodes.hebrew:
        case enum_langCodes.arabic:
            return enum_directions.rtl
        case enum_langCodes.english:
        case enum_langCodes.spanish:
        case enum_langCodes.french:
        case enum_langCodes.dutch:
        default:
            return enum_directions.ltr
    }
}

// helper_addToArrIfNotExist
export const helper_combineArrWithoutDuplicate = (arr1, arr2) => {

    let ans = arr1.slice()

    arr2.forEach(val => {
        if(!ans.includes(val)){
            ans.push(val)
        }
    });


    return ans

}

// helper_getDisplayLang
export const helper_getDisplayLang_e = (systemLangCode, langArr, mainLang) => {

    if(langArr == null || mainLang == null){
        return systemLangCode
    }

    if(langArr.indexOf(systemLangCode) > -1){
        return systemLangCode
    }else {
        return mainLang
    }

}

// helper_arrayToObj_an
export const helper_arrayToObj_an = (arr) => {
    return Object.assign({}, arr)
}

// helper_getPercentage_n
export const helper_getPercentage_n = (val, percentage) =>{
    return (val * percentage) / 100
}

// helper_calculateSum_n
export const helper_calculateSum_n = (numOfValues_n ,valAvg_n, newVal_n) =>{


    return ((valAvg_n * numOfValues_n) + newVal_n) / (numOfValues_n + 1)
}

// helper_animateValue
export const helper_animateValue = (element_o, start, end, duration) => {

    if(element_o == null){
        return
    }
    let range = end - start;
    let current = start;
    let increment = end > start? 1 : -1;
    let stepTime = Math.abs(Math.floor(duration / range));
    let timer = setInterval(function() {
        current += increment;
        element_o.innerHTML = current;
        if (current == end) {
            clearInterval(timer);
        }
    }, stepTime);
}

// helper_millSecToStartingQuest_t
export const helper_millSecToStartingQuest_t = (questEvent_c, gameStatus_c, currentTeamId_uid) => {

    let startingTime_t = null

    switch(questEvent_c.qev_startClockType_e){
        case enum_questEventStartClockTypes_s.eventStartClock:
            if(questEvent_c){
                startingTime_t = questEvent_c.qev_startingDate_t
            }
            break;

        case enum_questEventStartClockTypes_s.creatorStartClock:

            if(gameStatus_c != null){
                startingTime_t =  gameStatus_c.gs_creatorStartTime_t
            }
            break;
        case enum_questEventStartClockTypes_s.playerStartClock:

            if(gameStatus_c != null && gameStatus_c.gs_teams_byTeamId[currentTeamId_uid] != null) {
                startingTime_t = gameStatus_c.gs_teams_byTeamId[currentTeamId_uid].gst_playerStartTime_t
            }
            break;
    }


    if(startingTime_t == null){return null}

    let now_t = (date_newDate_fd()).getTime()

    return startingTime_t - now_t
}

// helper_millSecToEndingQuest_n
export const helper_millSecToEndingQuest_n = (millSecToStart_n, questEvent_c, gameStatus_c) => {

    let timeExtension_n = gameStatus_c != null ? gameStatus_c.gs_timeExtensionMinutes_n : 0

    return millSecToStart_n + (questEvent_c.qev_durationInMinutes_n + timeExtension_n) * 60 * 1000

}

// helper_getEventClockStatus_e
export const helper_getEventClockStatus_e = (millSecToStart_n, millSecToEnd_n) => {

    // check startingTime
    if(millSecToStart_n == null){
        return enum_questEventStatus.didntStart
    } else if( millSecToStart_n > 0){
        return enum_questEventStatus.waiting
    }else if(millSecToEnd_n > 0 ){
        return enum_questEventStatus.ongoing
    }else{
        return enum_questEventStatus.finish
    }


}

// helper_getDistanceBetweenTwoPoints_fn
export const helper_getDistanceBetweenTwoPoints_fn = (lat1, lon1, lat2, lon2) => {


    let R = 6378.137; // Radius of earth in KM
    let dLat = lat2 * Math.PI / 180 - lat1 * Math.PI / 180;
    let dLon = lon2 * Math.PI / 180 - lon1 * Math.PI / 180;
    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon/2) * Math.sin(dLon/2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    let d = R * c;
    return d * 1000; // meters

    // let a = x1 - x2;
    // let b = y1 - y2;

    // console.log("Distance", Math.sqrt( a*a + b*b ))
    // return 1000000 * Math.sqrt( a*a + b*b );
}

// helper_newTextByLangCode_blc_s
export const helper_newTextByLangCode_blc_s = ({english, hebrew, french, spanish}) => {

    return {
        iw : hebrew,
        en : hebrew,
        fr : french,
        es : spanish,
    }
}

// helper_newTextByLangCode_blc_s
export const helper_addTextInMiddleOfByLangCode_f = ({first_blc_s, seconds_blc_s, middle_s}) => {

    return {
        iw : first_blc_s.iw + middle_s + seconds_blc_s.iw,
        en : first_blc_s.en + middle_s + seconds_blc_s.en,
        fr : first_blc_s.fr + middle_s + seconds_blc_s.fr,
        es : first_blc_s.es + middle_s + seconds_blc_s.es,
    }
}

// helper_didNotification_b
export const helper_getRiddleStatusKey_s = ({questType_e, questId_uid, subCollection_teamStatus_e, riddleId_n, finishTimestamp_t}) => {
    let key = `${questType_e}_${questId_uid}_${subCollection_teamStatus_e}_${riddleId_n}_${finishTimestamp_t}`
    return key

}

// helper_nextString_s
export const helper_prevString_s = (str) => {

    let lastIndex_n = str.length-1
    let charCode_n  = str.charCodeAt(str.length-1)-1

    return str.substring(0, lastIndex_n) + String.fromCharCode(charCode_n)
}

// helper_randomNum
export const helper_randomNum_n = (maxNum_n) => {
    // returns a random integer from 0 to maxNum -1
    return Math.floor(Math.random() * maxNum_n)
}

// helper_getFinishDuration_fs
export const helper_getFinishDuration_fs = ({questEvent_c, gameStatus_c, teamId_uid, clockStartClock_e}) => {

    let gs_team_c = gameStatus_c.gs_teams_byTeamId[teamId_uid]

    // team not exist
    if(gs_team_c  == null){
        return "-"
    }

    let startTime_t = null
    switch(clockStartClock_e){

        case enum_questEventStartClockTypes_s.creatorStartClock:
            startTime_t = gameStatus_c.gs_creatorStartTime_t;

            break;
        case enum_questEventStartClockTypes_s.playerStartClock:
            startTime_t = gs_team_c.gst_playerStartTime_t;

            break;
        case enum_questEventStartClockTypes_s.eventStartClock:
            startTime_t = questEvent_c.qev_startingDate_t
            break;
    }

    // quest didnt start
    if(startTime_t == null){
        return "-"
    }

    // team didnt finish the game
    if(gs_team_c.gst_finishTime_t == null){

        let totalQuestDurationSeconds_n = (questEvent_c.qev_durationInMinutes_n + gameStatus_c.gs_timeExtensionMinutes_n)*60

        // quest over
        if(-date_getDurationToStartEvent_seconds(startTime_t) > totalQuestDurationSeconds_n ){
            return format_duration_hhmmss(totalQuestDurationSeconds_n*1000)
        }

        // quest not ever
        return "-"
    }

    // team finish quest
    return format_duration_hhmmss(gs_team_c.gst_finishTime_t - startTime_t)
}

// helper_getDiffObj_fo
export const helper_getDiffObj_fo = (diffLevel_n) => {

    let ans = [
        {img_r : ass_img_diffLevel0_gray,   text_s : ""},
        {img_r : ass_img_diffLevel1_c,      text_s : ass_strings.twoWords_veryEasy},
        {img_r : ass_img_diffLevel2_c,      text_s : ass_strings.oneWord_easy},
        {img_r : ass_img_diffLevel3_c,      text_s : ass_strings.oneWord_medium},
        {img_r : ass_img_diffLevel4_c,      text_s : ass_strings.oneWord_hard},
        {img_r : ass_img_diffLevel5_c,      text_s : ass_strings.twoWords_veryHard},
    ]

    return ans[Math.round(diffLevel_n)]
}

// helper_getDiffLevel_o
export const helper_getDiffLevel_o =(diffLevel_n, langCode_e) => {
    if(diffLevel_n < 1) {
        return {img_r: ass_img_diffLevel0_gray, text_s: ass_strings.twoWords_noReviews[langCode_e]}
    }else if(diffLevel_n < 1.5){
        return {img_r : ass_img_diffLevel1_c,   text_s : ass_strings.twoWords_veryEasy[langCode_e]}
    }else if(diffLevel_n < 2.5){
        return {img_r : ass_img_diffLevel2_c,   text_s : ass_strings.oneWord_easy[langCode_e]}
    }else if(diffLevel_n < 3.5){
        return {img_r : ass_img_diffLevel3_c,   text_s : ass_strings.oneWord_medium[langCode_e]}
    }else if(diffLevel_n < 4.5){
        return {img_r : ass_img_diffLevel4_c,   text_s : ass_strings.oneWord_hard[langCode_e]}
    }else{
        return {img_r : ass_img_diffLevel5_c,   text_s : ass_strings.twoWords_veryHard[langCode_e]}
    }
}

// helper_getGeneralRating_o
export const helper_getGeneralRating_o = (generalRating_n, langCode_e) => {
    if(generalRating_n < 1){
        return {  text_s : ass_strings.twoWords_noReviews[langCode_e]}
    }else if(generalRating_n < 1.5){
        return {  text_s : ass_strings.twoWords_poor[langCode_e]}
    }else if(generalRating_n < 2.5){
        return {  text_s : ass_strings.oneWord_fair[langCode_e]}
    }else if(generalRating_n < 3.5){
        return {  text_s : ass_strings.oneWord_good[langCode_e]}
    }else if(generalRating_n < 4.5){
        return {  text_s : ass_strings.twoWords_VeryGood[langCode_e]}
    }else{
        return {  text_s : ass_strings.oneWord_excellent[langCode_e]}
    }
}

// helper_getMapTilerStyle_f
export const helper_getMapTilerStyle_f = (langCode_e) => {


    switch(langCode_e){
        case enum_langCodes.hebrew:
            return mapTilerStyles_s.default
        case enum_langCodes.spanish:
            return mapTilerStyles_s.spanish
        case enum_langCodes.french:
            return mapTilerStyles_s.french
        case enum_langCodes.english:
        default:
            return mapTilerStyles_s.english
    }
}

// helper_getTicketStatusClass_fs
export const helper_getTicketStatusClass_fs = (status_e) => {

    switch(status_e){
        case enum_questTicketStatus.approved:
        case enum_questTicketStatus.charged:
        case enum_questTicketStatus.creatorRequestApproved:
            return 'TQ_bg_green'

        case enum_questTicketStatus.creatorRequest:
        case enum_questTicketStatus.waitingToApprove:
            return 'TQ_bg_gold'

        case enum_questTicketStatus.expired:
        case enum_questTicketStatus.canceled:
        case enum_questTicketStatus.creatorRequestDecline:
            return 'TQ_bg_red'


    }

}

// helper_hashStr_fs
export const helper_hashStr_fs = (strToHash_s) => {
    let hash = 0, i, chr;
    if (strToHash_s.length === 0) return hash;
    for (i = 0; i < strToHash_s.length; i++) {
        chr   = strToHash_s.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

// helper_getLangFlagWithLangCode_fr
export const helper_getLangFlagWithLangCode_fr = (langCode) => {
    switch(langCode){
        case enum_langCodes.english:
            return ass_img_flagUsa_c
        case enum_langCodes.hebrew:
            return ass_img_flagIsrael_c
        case enum_langCodes.french:
            return ass_img_flagFrench_c
        case enum_langCodes.spanish:
            return ass_img_flagSpain_c
        case enum_langCodes.arabic:
            return ass_img_flagEgypt_c
        case enum_langCodes.dutch:
            return ass_img_flagNetherlands_c
    }
}

// helper_features_totalAvailableQuests_n
export const helper_features_totalAvailableQuests_n = (userTotalPoints_n) => {

    if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_20]){
        return 20
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_15]){
        return 15
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_10]){
        return 10
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_8]){
        return 8
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_6]){
        return 6
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_4]){
        return 4
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_2]){
        return 2
    }else {
        return 1
    }
}

// helper_features_totalAvailableQuests_n
export const helper_features_totalAvailableQuests_e = (userTotalPoints_n) => {

    if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_20]){
        return enum_moreInfo_featuresIds_s.feature_numQuests_20
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_15]){
        return enum_moreInfo_featuresIds_s.feature_numQuests_15
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_10]){
        return enum_moreInfo_featuresIds_s.feature_numQuests_10
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_8]){
        return enum_moreInfo_featuresIds_s.feature_numQuests_8
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_6]){
        return enum_moreInfo_featuresIds_s.feature_numQuests_6
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_4]){
        return enum_moreInfo_featuresIds_s.feature_numQuests_4
    }else if(userTotalPoints_n >= enum_featuresMinPoints[enum_moreInfo_featuresIds_s.feature_numQuests_2]){
        return enum_moreInfo_featuresIds_s.feature_numQuests_2
    }else {
        return enum_moreInfo_featuresIds_s.feature_numQuests_1
    }
}

